import { Select, type SelectProps } from '@aigc/antd';
import { useQuery } from '@tanstack/react-query';
import type { Ref } from 'react';
import { getSkillOptionssQueryOptions } from '../api';

export const SkillSelect = (
  props: SelectProps<number> & { ref?: Ref<typeof Select> },
) => {
  const { data, isPending } = useQuery(getSkillOptionssQueryOptions());

  return (
    <Select
      {...props}
      loading={isPending}
      options={data?.map((item) => ({
        label: item.name,
        value: item.id,
        title: item.description ?? void 0,
      }))}
    ></Select>
  );
};
